/* Load once, deferred, after the theme's pubsub.js. No selling or stock writes. */
/* global subscribe, PUB_SUB_EVENTS */
if (!customElements.get('launch-availability-notice')) {
  customElements.define('launch-availability-notice', class extends HTMLElement {
    connectedCallback() {
      if (this.connected) return;
      this.connected = true;
      this.scheduleExpiry();
      this.owner = this.closest('product-info') || this.closest('.product__info-container') || this.parentElement;
      this.applyShopNowLabel();
      this.hideOnSelection = event => {
        if (event.target.closest('variant-radios, variant-selects')) this.hidden = true;
      };
      this.owner?.addEventListener('change', this.hideOnSelection);
      if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') {
        this.hidden = true;
        return;
      }
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, event => {
        const sourceSection = this.dataset.originalSection || this.dataset.section;
        if (String(event.data?.sectionId) !== sourceSection) return;
        const source = event.data.html?.getElementById('LaunchAvailability-' + sourceSection);
        if (!source || source.dataset.variantId !== String(event.data.variant?.id)) {
          this.hidden = true;
          return;
        }
        this.innerHTML = source.innerHTML;
        this.dataset.variantId = source.dataset.variantId;
        this.dataset.expiresEpoch = source.dataset.expiresEpoch;
        this.dataset.shopNowLabel = source.dataset.shopNowLabel || '';
        this.hidden = source.hidden;
        this.applyShopNowLabel();
        this.scheduleExpiry();
      });
    }
    disconnectedCallback() {
      clearTimeout(this.expiryTimer);
      this.unsubscribe?.();
      this.unsubscribe = undefined;
      this.connected = false;
      this.owner?.removeEventListener('change', this.hideOnSelection);
    }
    applyShopNowLabel() {
      const button = this.owner?.querySelector?.('[id^="ProductSubmitButton-"]');
      if (!this.dataset.shopNowLabel || !button || button.disabled || button.closest('product-form')?.dataset.comingSoon === 'true') return;
      const text = button.querySelector('[id^="ProductSubmitText-"]');
      if (text) text.textContent = this.dataset.shopNowLabel;
    }
    scheduleExpiry() {
      clearTimeout(this.expiryTimer);
      const expiry = Number(this.dataset.expiresEpoch) * 1000;
      if (!Number.isSafeInteger(expiry) || expiry <= Date.now()) {
        this.hidden = true;
        return;
      }
      this.expiryTimer = setTimeout(() => this.scheduleExpiry(), Math.min(expiry - Date.now(), 2147483647));
    }
  });
}